console.log('test A');

window.$ = jQuery
import './components/btn'

function init() {
}

$(init())
